import * as React from "react";
import type { SVGProps } from "react";
const HomeHealthCare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0_4362_7589)">
      <g clipPath="url(#clip1_4362_7589)">
        <path
          fill="currentColor"
          d="M5.1429 5.1425V2.046c0-.7125.4446-1.3554 1.1142-1.6072L11.4-1.4897c.3857-.1446.8143-.1446 1.2054 0L17.7482.439a1.7155 1.7155 0 0 1 1.1143 1.6072v3.0964h-.0161a5.6 5.6 0 0 1 .0161.4285v2.143c0 3.7874-3.0696 6.8571-6.8571 6.8571S5.1482 11.5015 5.1482 7.714V5.5711c0-.1447.0054-.2893.016-.4286zm2.5714 2.5714c0 2.3679 1.9178 4.2857 4.2857 4.2857s4.2857-1.9178 4.2857-4.2857v-.8571H7.7143zm-1.7197 8.1268c.5625-.1821 1.1679.0214 1.575.4554l3.8036 4.0446c.3375.3589.9107.3589 1.2482 0l3.8036-4.0446c.4071-.434 1.0125-.6375 1.575-.4554 3.4821 1.1196 6 4.3768 6 8.2286 0 .9107-.7393 1.6446-1.6446 1.6446H1.6446C.7393 25.7139 0 24.9746 0 24.0693c0-3.8518 2.5179-7.109 5.9946-8.2286M11.143.8567v.8572h-.8572a.43.43 0 0 0-.4286.4286v.8571c0 .2357.1929.4286.4286.4286h.8572v.8571c0 .2357.1928.4286.4285.4286h.8572a.43.43 0 0 0 .4285-.4286v-.8571h.8572a.43.43 0 0 0 .4286-.4286v-.8571a.43.43 0 0 0-.4286-.4286h-.8572V.8568a.43.43 0 0 0-.4285-.4286h-.8572a.43.43 0 0 0-.4285.4286"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_4362_7589">
        <path fill="transparent" d="M0 0h24v24H0z" />
      </clipPath>
      <clipPath id="clip1_4362_7589">
        <path fill="transparent" d="M0-1.7144h24v27.4286H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default HomeHealthCare;
